import { supportLanguage } from '@/config/i18nConfig'
import { SUPPORT_LANGUAGE } from '@/config/platform'
import Head from 'next/head'
import { usePathname } from 'next/navigation'

const wwwUrl = 'https://www.17track.net'

function SeoLinks({ lang }: { lang: string }) {
  const pathname = usePathname()
  const actualPath = pathname === '/' ? '' : pathname
  const canonicalUrl = `${wwwUrl}/${lang}${actualPath}`
  const xDefaultHrefUrl = `${wwwUrl}/en${actualPath}`
  // brands 支持部分语言 SUPPORT_LANGUAGE
  const langs = actualPath?.indexOf('brands') !== -1 ? SUPPORT_LANGUAGE : supportLanguage.slice(1) // brands路由支持语言限制

  const linksArr = langs?.map((lang) => {
    const hrefUrl = `${wwwUrl}/${lang}${actualPath}`
    const hreflang = lang === 'zh-cn' ? 'zh-Hans' : lang === 'zh-hk' ? 'zh-Hant' : lang
    return <link rel="alternate" hrefLang={hreflang} href={hrefUrl} key={lang} />
  })

  return (
    <Head>
      {canonicalUrl && <link rel="canonical" href={canonicalUrl} />}
      {xDefaultHrefUrl && <link rel="alternate" hrefLang="x-default" href={xDefaultHrefUrl} />}
      {linksArr}
    </Head>
  )
}

export default SeoLinks
